import React, { useMemo, useState } from 'react';
import { useModal } from '../../../../hooks/useModal';
import { useUser } from '../../../../redux/reducer/user';
import ShopItem from './ShopItem';

const ShopItems = React.forwardRef(function ShopItems({ callbacks, necessaryItems }, ref) {
  const { addModal } = useModal();

  const clickOnItem = ({ item, product }) => {
    addModal({
      type: 'shopModal',
      props: { itemId: item.id, productId: product.id, callbacks },
    });
  };

  return (
    <div className={'shop__items'}>
      {necessaryItems.map(({ item, product, status }, index) => (
        <ShopItem
          key={index}
          index={index}
          item={item}
          product={product}
          status={status}
          onClick={() => clickOnItem({ item, product })}
        />
      ))}
    </div>
  );
});

export default ShopItems;
ShopItems.propTypes = {};
